import axios from 'axios'
import Vue from 'vue'
import qs from "qs";

const state = {
    userData: '',
}

let config = function (params) {
    let result = {
        headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
        withCredentials: true,
        paramsSerializer: function(params) {
            return qs.stringify(params, {arrayFormat: 'repeat'})
        },
    }
    if(params){
        result.params =  params
    }
    return result;
}

const getters = {}
const mutations = {
    setData(state, data) {
        state.userData = data;
    },
}
const actions = {
    getUseName(context, data){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH + '/user/contractunauth/', config({'url':data})).then(response => {
                resolve(response.data.result.items);
                /*if (typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('setData', response.data.result.items);
                } else {
                    if (+response.data.error === 401) {
                        context.dispatch('auth/logout', {}, {root: true})
                    }
                    if( +response.data.error===401){
                        context.dispatch('auth/logout',{},{root:true})
                    }
                }
                resolve();*/
            }).catch(function (error) {
                //resolve();
                //context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
            });
        });    
    },
    getContractData(context, data) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH + '/user/contract/', config({})).then(response => {
                if (typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('setData', response.data.result.items);
                } else {
                    if (+response.data.error === 401) {
                        context.dispatch('auth/logout', {}, {root: true})
                    }
                    if( +response.data.error===401){
                        context.dispatch('auth/logout',{},{root:true})
                    }
                }
                resolve();
            }).catch(function (error) {
                resolve();
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
            });
        });
    },
    runStep(context, data) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            for ( let key in data) {
                formData.append(key, data[key]);
            }

            axios.post(process.env.VUE_APP_API_PATH + '/user/contract/', formData, config()).then(response => {
                if (typeof response.data === 'object' && +response.data.error === 0) {
                    //context.commit('setSample', response.data.result.items);
                } else {
                    if (+response.data.error === 401) {
                        context.dispatch('auth/logout', {}, {root: true})
                    }
                    if( +response.data.error===401){
                        context.dispatch('auth/logout',{},{root:true})
                    }
                }
                resolve();
            }).catch(function (error) {
                resolve();
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
            });
        });   
    },
    upload(context, data) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            for ( let key in data) {
                formData.append(key, data[key]);
            }

            axios.post(process.env.VUE_APP_API_PATH + '/user/contract/', formData, config()).then(response => {
                if (typeof response.data === 'object' && +response.data.error === 0) {
                    //context.commit('setSample', response.data.result.items);
                } else {
                    if (+response.data.error === 401) {
                        context.dispatch('auth/logout', {}, {root: true})
                    }
                    if( +response.data.error===401){
                        context.dispatch('auth/logout',{},{root:true})
                    }
                }
                resolve();
            }).catch(function (error) {
                resolve();
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
            });
        });   
    }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}